"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EthTransactionPair = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
class EthTransactionPair {
  constructor(transaction, receipt, methods) {
    (0, _defineProperty2.default)(this, "hash", void 0);
    (0, _defineProperty2.default)(this, "transaction", void 0);
    (0, _defineProperty2.default)(this, "receipt", void 0);
    (0, _defineProperty2.default)(this, "method", void 0);
    (0, _defineProperty2.default)(this, "altMethods", void 0);
    // confirmations is always null, so remove it
    this.transaction = Object.fromEntries(Object.entries((0, _remeda.omit)(transaction, ["confirmations"])).map(([key, val]) => {
      // @ts-ignore
      if (val !== null && val !== void 0 && val._hex) {
        return [key, val.toString()];
      }
      return [key, val];
    }));
    this.receipt = Object.fromEntries(Object.entries(receipt).map(([key, val]) => {
      // @ts-ignore
      if (val !== null && val !== void 0 && val._hex) {
        return [key, val.toString()];
      }
      return [key, val];
    }));
    this.receipt.status = receipt.status || 1;
    this.hash = transaction.hash;
    this.method = methods === null || methods === void 0 ? void 0 : methods[0];
    if ((methods === null || methods === void 0 ? void 0 : methods.length) > 1) {
      this.altMethods = methods.slice(1);
    }
  }
}
exports.EthTransactionPair = EthTransactionPair;
//# sourceMappingURL=EthTransactionPair.js.map